import useHttpBase from './useHttpBase';
import useHttpFileUpload from './useHttpFileUpload';

export {
  useHttpFileUpload,
};

export default useHttpBase;
